export interface SelectedItemModel {
  $selected: boolean;
}
